import * as React from 'react'

import { CommandLine, CommandLineReactContextType } from 'providers/CommandLineWrapper'

export type CommandLineAccessorProps = Pick<CommandLineReactContextType, 'addContext' | 'removeContext'>

// NOTE: use this HOC for react class components which need to access
// the command line context
export const withCommandLineAccessors =
  <P extends CommandLineAccessorProps>(Component: React.ComponentType<React.PropsWithChildren<P>>) =>
  (props: Omit<P, keyof CommandLineAccessorProps>) => {
    return (
      <CommandLine.Consumer>
        {({ addContext, removeContext }) => (
          <Component addContext={addContext} removeContext={removeContext} {...(props as any)} />
        )}
      </CommandLine.Consumer>
    )
  }
